// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatIconModule } from '@angular/material/icon';

// Other External Files

// Component Files
import { TellerOnlineIconsModule } from 'teller-online-libraries/icons';
import { PaymentMethodDisplayComponent } from './payment-method-display.component';

// Teller Online Files

// Teller Online Library Files

@NgModule({
    declarations: [PaymentMethodDisplayComponent],
    imports: [
        CommonModule,
        MatIconModule,
        TellerOnlineIconsModule
    ],
    exports: [PaymentMethodDisplayComponent]
})
export class PaymentMethodDisplayModule {}
